import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App.tsx";
import { store, persistor } from "./store";
import { AuthProvider } from "@components/providers/AuthProvider";
import { I18nProvider } from "@components/providers/I18nProvider";
import ErrorFallback from "@components/common/ErrorFallback";

// Initialize i18n
// import "./utils/i18n";

import "./styles/index.css";
import { ToastProvider } from "./components/ui/ToastContext.tsx";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <I18nProvider>
              <AuthProvider>
                <ToastProvider>
                  <Toaster position="top-right" />
                  <App />
                </ToastProvider>
              </AuthProvider>
            </I18nProvider>
          </BrowserRouter>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  // </React.StrictMode>,
);
